import { TeamSeats } from '../../../common/hooks/use-team-api.hook';

/** Seats still free to invite into; undefined when the plan has no limit. */
export const seatsLeft = (seats?: TeamSeats | null): number | undefined =>
    !seats || seats.limit < 0 ? undefined : Math.max(0, seats.limit - seats.used - seats.reserved);
